import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import homepageTranslations from '@/lib/homepageTranslations.json';
import Link from 'next/link';

interface CebinovSectionProps {
  currentLang?: 'sl' | 'en';
}

export default function CebinovSection({ currentLang = 'sl' }: CebinovSectionProps) {
  const lang = currentLang === 'en' ? 'en' : 'sl';
  const features = homepageTranslations.cebinov.features.map((feature, index) => ({
    id: `feature_${index}`,
    icon: 'CogIcon',
    title: feature.title[lang],
    description: feature.description[lang],
  }));

  const content = {
    label: homepageTranslations.cebinov.label[lang],
    title: homepageTranslations.cebinov.title[lang],
    description: homepageTranslations.cebinov.description[lang],
    intro: homepageTranslations.cebinov.intro[lang],
    intro2: homepageTranslations.cebinov.intro2[lang],
    features,
    cta: homepageTranslations.cebinov.cta[lang],
  };

  return (
    <section className="py-32 px-6 md:px-10 max-w-7xl mx-auto">
      <div className="mb-12">
        <p className="text-xs font-bold uppercase tracking-[0.4em] text-muted-foreground mb-4">
          {content.label}
        </p>
        <h2 className="text-5xl md:text-6xl font-bold tracking-tighter">{content.title}</h2>
      </div>

      <div className="grid lg:grid-cols-12 gap-8">
        {/* Large Image */}
        <div className="lg:col-span-7 aspect-[16/10] card-rounded overflow-hidden bg-muted">
          <AppImage
            src="/images/cebinov.webp"
            alt="Modern beekeeping equipment and machinery in workshop setting"
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
          />
        </div>

        {/* Feature Cards */}
        <div className="lg:col-span-5 space-y-6">
          {/* Description Card */}
          <div className="bg-card card-rounded p-8 shadow-lg">
            <p className="text-base leading-relaxed text-muted-foreground mb-6">
              {content.description}
            </p>
            <p className="text-base leading-relaxed text-muted-foreground mb-6">{content.intro}</p>
            <p className="text-base leading-relaxed text-muted-foreground mb-6">{content.intro2}</p>
            <Link
              href="/cebinov"
              className="inline-flex items-center gap-2 text-sm font-bold text-primary hover:gap-4 transition-all"
            >
              {content.cta}
              <Icon name="ArrowRightIcon" size={16} />
            </Link>
          </div>

          {/* Feature Cards */}
          {/* {content.features.map((feature) => (
            <div
              key={feature.id}
              className="bg-card card-rounded p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={feature.icon} size={24} className="text-primary" />
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2">{feature.title}</h3>
                  <p className="text-sm text-muted-foreground">{feature.description}</p>
                </div>
              </div>
            </div>
          ))} */}
        </div>
      </div>
    </section>
  );
}
